module.exports = __webpack_public_path__ + "a09475844d1886dc36f85055cc2f1658.png";